// Copyright (c) 2020 Comsearch, Inc., All rights reserved

// prepare the curve type code information so that it
// so that it can be used in formatting the radio modulation data in the
// radio details page.

const getCurveTypeIdMap = () => (dispatch, getState) => (
  getState().domain.getIn(['radioSettings', 'curveTypeCodes'])
    .reduce((a, d) => {
      a[d.get('curveTypeCodeId')] = d.get('curveTypeCode')
      return a
    }, {})
)

export default getCurveTypeIdMap
